import { createSelector } from "reselect";
import * as helpers from "../helpers";
import { LOCATION } from "../consts";
import { deepGet } from "../../../utils";

const configSelector = state => state.config;
const bookingSelector = state => state.booking;
const appointmentSelector = state => state.appointment;
const dataSourceSelector = state => state.dataSource;

const getState = (config, booking, appointment, dataSource) => {
  let text = "";
  const locationFirst = !config.practitionerFirst;
  const preSelectPractitioner = config.preSelectPractitioner;
  const schedules = helpers.filterSchedulesByPractitioner(
    dataSource.schedules,
    appointment.practitioner,
    locationFirst,
    preSelectPractitioner === "ANY"
  );

  const { positions } = dataSource;

  const options = helpers
    .filterLocationsBySchedules(dataSource.locations, schedules)
    .map(l => {
      return { ...l, position: positions[l.locationId] };
    });

  const required = options.length !== 1;
  const value = required
    ? deepGet(appointment, [LOCATION])
    : options[0].locationId;
  if (appointment.location) {
    if (appointment.location === "ANY") {
      text = "Any location";
    } else {
      const location = dataSource.locations.find(
        l => l.locationId === appointment.location
      );
      if (location) {
        text = `${location.name}, ${location.suburb}`;
      }
    }
  }
  const isTimeZoneUnique = helpers.isTimeZoneUnique(options);

  return {
    text,
    hintText: config.locationHintText,
    siteConsultTypes: config.siteConsultTypes,
    isOpen: booking.controlVisibility[LOCATION],
    value,
    options,
    timeZones: dataSource.timeZones,
    isTimeZoneUnique,
    required,
    completed: booking.completedSteps.includes(LOCATION),
    reload: booking.reload,
    locationFirst
  };
};

const locationSelector = createSelector(
  configSelector,
  bookingSelector,
  appointmentSelector,
  dataSourceSelector,
  getState
);

export { locationSelector };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/selectors/locationSelector.js